import { computed, inject, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { OverviewItem } from '@shared/models/overview.model';
import { OverviewApiService } from '@shared/services/overview-api/overview-api.service';

export interface OverviewStoreState {
  overview?: OverviewItem[];
}

@Injectable({ providedIn: 'root' })
export class OverviewStore {
  private readonly overviewApi = inject(OverviewApiService);

  private readonly state = signal<OverviewStoreState>({});

  readonly overview = computed(() => this.state().overview);

  fetchOverview(organizationId?: number): Observable<OverviewItem[]> {
    return this.overviewApi
      .fetchOverviewData(organizationId)
      .pipe(tap((overview: OverviewItem[]) => this.state.update((current) => ({ ...current, overview }))));
  }
}
